import React from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { DASHBOARD } from 'pathnames.js';

// HELPERS
import { getListData } from 'helpers/getListData';

// LOCAL PARTS
import DashboardIndex from './parts/DashboardIndex';

// MAIN COMPONENT
const Favorites = () => (
  <DashboardIndex
    title="My Favorites"
    pathname={DASHBOARD.favorites}
  />
);

export default getListData(Favorites, {
  key: 'favoritesReports',
  fetchArgs: {
    endpoint: ENDPOINTS.dashboard.favorites
  }
});
